import { managerInstance, backendVersion } from "@/axios-path.js";

export default {
    namespaced: true,
    state: {
        invoiceManagerList: []
    },
    mutations: {
        setInvoiceManagerList(state, data) {
            state.invoiceManagerList = data;
        },
        addInvoiceManagerItem(state, data) {
            state.invoiceManagerList.push(data)
        },
        updateInvoiceManagerItem(state, data) {
            let index = state.invoiceManagerList.findIndex(val => val.bill_id == data.bill_id)
            state.invoiceManagerList.splice(index, 1, data)
        },
        removeInvoiceManagerItem(state, invoice_id) {
            let index = state.invoiceManagerList.findIndex(val => val.bill_id == invoice_id)
            state.invoiceManagerList.splice(index, 1)
        }
    },
    actions: {
        async fetchInvoiceManagerList({ commit }, { manager_id }) {
            let url = `${backendVersion.version}/partner/get_bill_manager_backoffice/${manager_id}`;
            return managerInstance
                .get(url)
                .then((res) => {
                    if (res.msg == false) return false;
                    commit('setInvoiceManagerList', res.data)
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async fetchInvoiceManagerByID({ }, { manager_id, invoice_id }) {
            let url = `${backendVersion.version}/partner/get_bill_manager_backoffice/${manager_id}/${invoice_id}`;
            return managerInstance
                .get(url)
                .then((res) => {
                    if (res.msg == false) return false;
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async createInvoiceManager({ commit }, { form }) {
            let url = `${backendVersion.version}/partner/create_bill_manager_backoffice`;
            let payload = {
                "bill_type": form.bill_type,
                "bill_provider": form.bill_provider,
                "bill_number": form.bill_number,
                "bill_description": form.bill_description,
                "bill_issuer_name": form.bill_issuer_name,
                "bill_issuer_address": form.bill_issuer_address,
                "bill_issuer_tax_id": form.bill_issuer_tax_id,
                "bill_customer_name": form.bill_customer_name,
                "bill_customer_address": form.bill_customer_address,
                "bill_customer_tax_id": form.bill_customer_tax_id,
                "bill_detail": form.bill_detail,
                "bill_user_partner_id": form.bill_user_partner_id,
                "bill_district_id": form.bill_district_id,
                "bill_amount_price": form.bill_amount_price,
                "bill_discount_price": form.bill_discount_price,
                "bill_deposit_price": form.bill_deposit_price,
                "bill_vat_price": form.bill_vat_price,
                "bill_net_price": form.bill_net_price,
                "bill_net_price_text": form.bill_net_price_text,
                "bill_due_date": form.bill_due_date
            };

            return managerInstance
                .post(url, payload)
                .then((res) => {
                    if (res.msg == false) return false;
                    commit('addInvoiceManagerItem', res.data)
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async editInvoiceManager({ commit }, { form }) {
            let url = `${backendVersion.version}/partner/update_bill_manager_backoffice`;
            let payload = {
                "bill_id": form.bill_id,
                "bill_type": form.bill_type,
                "bill_provider": form.bill_provider,
                "bill_number": form.bill_number,
                "bill_description": form.bill_description,
                "bill_issuer_name": form.bill_issuer_name,
                "bill_issuer_address": form.bill_issuer_address,
                "bill_issuer_tax_id": form.bill_issuer_tax_id,
                "bill_customer_name": form.bill_customer_name,
                "bill_customer_address": form.bill_customer_address,
                "bill_customer_tax_id": form.bill_customer_tax_id,
                "bill_detail": form.bill_detail,
                "bill_user_partner_id": form.bill_user_partner_id,
                "bill_district_id": form.bill_district_id,
                "bill_amount_price": form.bill_amount_price,
                "bill_discount_price": form.bill_discount_price,
                "bill_deposit_price": form.bill_deposit_price,
                "bill_vat_price": form.bill_vat_price,
                "bill_net_price": form.bill_net_price,
                "bill_net_price_text": form.bill_net_price_text,
                "bill_due_date": form.bill_due_date
            }
            return managerInstance
                .put(url, payload)
                .then((res) => {
                    if (res.msg == false) return false;
                    commit('updateInvoiceManagerItem', res.data)
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async deleteInvoiceManager({ commit }, { invoice_id }) {
            let url = `${backendVersion.version}/partner/delete_bill_manager_backoffice/${invoice_id}`;
            return managerInstance
                .delete(url)
                .then((res) => {
                    if (res.msg == false) return false;
                    commit('removeInvoiceManagerItem', invoice_id)
                    return true;
                })
                .catch(() => {
                    return false;
                });
        },
    },
    getters: {}
};
